
import { FAQ } from "~/componentsDS/Accordion";
import { getTextFromNode } from "~/utils/getTextFromNode";

type Props = {
    items: FAQ[];
};

export const FAQSchema = ({ items = [] }: Props) => {
    if (!items.length) return null;

    const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: items.map((item) => ({
            "@type": "Question",
            name: getTextFromNode(item.question),
            acceptedAnswer: {
                "@type": "Answer",
                text: getTextFromNode(item.answer, " "),
            },
        })),
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(schema),
            }}
        />
    );
};

export default FAQSchema;
